import React, { FunctionComponent, useMemo } from 'react'
import { Input } from '@/components/Input'
import styles from './PasswordInput.module.scss'

const regexContainDigit = /^(?=.*\d).+$/
const regexContainLetter = /^(?=.*[A-zа-яА-ЯёЁ]).+$/

interface PasswordInputProps {
  value: string
  name?: string
  placeholder?: string
  className?: string
  error?: string
  onChange?: (value: string, name?: string) => void
}
export const PasswordInput: FunctionComponent<PasswordInputProps> = ({
  name = 'password',
  onChange = () => {},
  value,
  className = '',
  error,
  placeholder = 'Пароль',
}) => {
  const needLength = useMemo(() => {
    return value.length >= 8
  }, [value])

  const containDigit = useMemo(() => {
    return regexContainDigit.test(value)
  }, [value])

  const containLetter = useMemo(() => {
    return regexContainLetter.test(value)
  }, [value])

  const errorCount = useMemo(() => {
    return [containDigit, containLetter, needLength].filter((i) => !i).length
  }, [containDigit, containLetter, needLength])

  const errorText = useMemo(() => {
    if (errorCount === 0) {
      return null
    }
    let text = 'Пароль должен содержать '
    const containDigitText = 'цифры'
    const containLetterText = 'буквы'
    const needLengthText = '8+ символов'
    if (!needLength) {
      text += needLengthText
    }

    if (!containLetter) {
      const secondSeparator =
        errorCount === 2 ? ' и ' : errorCount !== 1 ? ', ' : ''
      text += `${secondSeparator} ${containLetterText}`
    }

    if (!containDigit) {
      text += `${errorCount !== 1 ? ' и ' : ''} ${containDigitText}`
    }

    return text
  }, [containDigit, containLetter, errorCount, needLength])

  return (
    <div
      className={`${styles.container} ${className}`}
      data-errors={errorCount}
    >
      <Input
        value={value}
        onChange={onChange}
        type="password"
        name={name}
        placeholder={placeholder}
      />
      <div className={styles.scale}>
        <div className={styles.scaleSection}></div>
        <div className={styles.scaleSection}></div>
        <div className={styles.scaleSection}></div>
      </div>
      {errorText || error ? (
        <div className={styles.message}>{errorText ?? error}</div>
      ) : null}
    </div>
  )
}
